/** Shared schema.org blocks (absolute URLs for crawlers). */
const ORIGIN = 'https://sati-architects.com';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SATI Architects',
  url: ORIGIN,
  logo: `${ORIGIN}/Sati_correct_logo_2.svg`,
  email: 'hello@sati-architects.com',
  telephone: '+380-97-412-9118',
  sameAs: [
    'https://www.instagram.com/sati.architects/',
    'https://www.facebook.com/sati.architects/',
  ],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'SATI Architects',
  url: ORIGIN,
};

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: it.href.startsWith('http') ? it.href : `${ORIGIN}${it.href.startsWith('/') ? it.href : `/${it.href}`}`,
    })),
  };
}
